const rewardTypeEnum = Object.freeze({
  COLLECTION: 'collection',
  PROMO: 'promo',
  MASS: 'mass',
  SPECIAL: 'special',
});

export default rewardTypeEnum;
